import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { PortalOneColumnLayout } from '../../components/PortalStructure';
require('./style.css');

interface IProps {
	t?: (key: string) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SizeGuide extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { t } = this.props;

		return (
			<PortalOneColumnLayout>
				<div className="wrapperSizeGuide">
					<div className="container sizeGuideContainer">
						<div className="mainTitleGuide">{t('SizeGuide_Label_SizeCharts')}</div>
						<div className="wrapperTabels">
							<Tabs name="sizeguidetabs" tabComponent="div" disableInlineStyles={true}>
								<div className="resultsTab">
									<a>
										<TabLink
											key="sizeguidetabwomenlink"
											activeClassName="tlinkActive"
											to={c.SIZEGUIDE_TAB_WOMEN}
											default={true}
										>
											{t('SizeGuide_Label_Women')}
										</TabLink>
									</a>
									<a>
										<TabLink key="sizeguidetabmenlink" activeClassName="tlinkActive" to={c.SIZEGUIDE_TAB_MEN}>
											{t('SizeGuide_Label_Men')}
										</TabLink>
									</a>
									<a>
										<TabLink key="sizeguidetabkidslink" activeClassName="tlinkActive" to={c.SIZEGUIDE_TAB_KIDS}>
											{t('SizeGuide_Label_Kids')}
										</TabLink>
									</a>
								</div>
								<div className="clear" />
								<TabContent
									key="sizeguidetabwomencontent"
									className="tab"
									visibleClassName="contentVisible"
									for={c.SIZEGUIDE_TAB_WOMEN}
								>
									<div className="wrapperTables">
										<div className="table">
											<div className="titleTable">{t('SizeGuide_Label_Clothes')}</div>
											<div>
												<table>
													<tbody>
														<tr>
															<td>{t('SizeGuide_Label_ITA')}</td>
															<td>36</td>
															<td>38</td>
															<td>40</td>
															<td>42</td>
															<td>44</td>
															<td>46</td>
															<td>48</td>
															<td>50</td>
															<td>52</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_US')}</td>
															<td>0</td>
															<td>0</td>
															<td>2-4</td>
															<td>4-6</td>
															<td>8</td>
															<td>10</td>
															<td>12</td>
															<td>14</td>
															<td>16</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_UK')}</td>
															<td>4</td>
															<td>6</td>
															<td>8</td>
															<td>10</td>
															<td>12</td>
															<td>14</td>
															<td>16</td>
															<td>18</td>
															<td>20</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_France')}</td>
															<td>32</td>
															<td>34</td>
															<td>36</td>
															<td>38</td>
															<td>40</td>
															<td>42</td>
															<td>44</td>
															<td>46</td>
															<td>48</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_Denmark')}</td>
															<td>30</td>
															<td>32</td>
															<td>34</td>
															<td>36</td>
															<td>38</td>
															<td>40</td>
															<td>42</td>
															<td>44</td>
															<td>46</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_Russia')}</td>
															<td>38</td>
															<td>40</td>
															<td>42</td>
															<td>44</td>
															<td>46</td>
															<td>48</td>
															<td>50</td>
															<td>52</td>
															<td>54</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_Germany')}</td>
															<td>30</td>
															<td>32</td>
															<td>34</td>
															<td>36</td>
															<td>38</td>
															<td>40</td>
															<td>42</td>
															<td>44</td>
															<td>46</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_Australia')}</td>
															<td>4</td>
															<td>6</td>
															<td>8</td>
															<td>10</td>
															<td>12</td>
															<td>14</td>
															<td>16</td>
															<td>18</td>
															<td>20</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_Japan')}</td>
															<td>3</td>
															<td>5</td>
															<td>7</td>
															<td>9</td>
															<td>11</td>
															<td>13</td>
															<td>15</td>
															<td>17</td>
															<td>19</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_Jeans')}</td>
															<td>23</td>
															<td>24-25</td>
															<td>26-27</td>
															<td>27-28</td>
															<td>29-30</td>
															<td>31-32</td>
															<td>32-33</td>
															<td />
															<td />
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_InternationalSize')}</td>
															<td>XXS</td>
															<td>XXS-XS</td>
															<td>XS-S</td>
															<td>S-M</td>
															<td>M-L</td>
															<td>L-XL</td>
															<td>XL-XXL</td>
															<td>XXL-XXXL</td>
															<td>XXXL</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
										<div className="table">
											<div className="titleTable">{t('SizeGuide_Label_Bras')}</div>
											<div>
												<table>
													<tbody>
														<tr>
															<td>{t('SizeGuide_Label_UK')}</td>
															<td>32B</td>
															<td>34B</td>
															<td>34C</td>
															<td>36B</td>
															<td>36C</td>
															<td>38B</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_ITA_EU')}</td>
															<td>70B</td>
															<td>75B</td>
															<td>75C</td>
															<td>80B</td>
															<td>80C</td>
															<td>85B</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_InternationalSize')}</td>
															<td>S</td>
															<td>M</td>
															<td>M</td>
															<td>L</td>
															<td>L</td>
															<td>XL</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
										<div className="table">
											<div className="titleTable">{t('SizeGuide_Label_Shoes')}</div>
											<div>
												<table>
													<tbody>
														<tr>
															<td>{t('SizeGuide_Label_ITA_EU')}</td>
															<td>34</td>
															<td>34.5</td>
															<td>35</td>
															<td>35.5</td>
															<td>36</td>
															<td>36.5</td>
															<td>37</td>
															<td>37.5</td>
															<td>38</td>
															<td>38.5</td>
															<td>39</td>
															<td>39.5</td>
															<td>40</td>
															<td>40.5</td>
															<td>41</td>
															<td>41.5</td>
															<td>42</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_US')}</td>
															<td>4</td>
															<td>4.5</td>
															<td>5</td>
															<td>5.5</td>
															<td>6</td>
															<td>6.5</td>
															<td>7</td>
															<td>7.5</td>
															<td>8</td>
															<td>8.5</td>
															<td>9</td>
															<td>9.5</td>
															<td>10</td>
															<td>10.5</td>
															<td>11</td>
															<td>11.5</td>
															<td>12</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_UK')}</td>
															<td>1</td>
															<td>1.5</td>
															<td>2</td>
															<td>2.5</td>
															<td>3</td>
															<td>3.5</td>
															<td>4</td>
															<td>4.5</td>
															<td>5</td>
															<td>5.5</td>
															<td>6</td>
															<td>6.5</td>
															<td>7</td>
															<td>7.5</td>
															<td>8</td>
															<td>8.5</td>
															<td>9</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_France')}</td>
															<td>35</td>
															<td>35.5</td>
															<td>36</td>
															<td>36.5</td>
															<td>37</td>
															<td>37.5</td>
															<td>38</td>
															<td>38.5</td>
															<td>39</td>
															<td>39.5</td>
															<td>40</td>
															<td>40.5</td>
															<td>41</td>
															<td>41.5</td>
															<td>42</td>
															<td>42.5</td>
															<td>43</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</TabContent>
								<TabContent
									key="sizeguidetabmencontent"
									className="tab"
									visibleClassName="contentVisible"
									for={c.SIZEGUIDE_TAB_MEN}
								>
									<div className="wrapperTables">
										<div className="table">
											<div className="titleTable">{t('SizeGuide_Label_OutwearAndTops')}</div>
											<div>
												<table>
													<tbody>
														<tr>
															<td>{t('SizeGuide_Label_ITA_EU')}</td>
															<td>40</td>
															<td>42</td>
															<td>44</td>
															<td>46</td>
															<td>48</td>
															<td>50</td>
															<td>52</td>
															<td>54</td>
															<td>56</td>
															<td>58</td>
															<td>60</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_InternationalSize')}</td>
															<td>XS</td>
															<td>XS</td>
															<td>S</td>
															<td>S</td>
															<td>M</td>
															<td>M</td>
															<td>L</td>
															<td>L</td>
															<td>XL</td>
															<td>XL</td>
															<td>XXL</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
										<div className="table">
											<div className="titleTable">{t('SizeGuide_Label_JeansAndTrousers')}</div>
											<div>
												<table>
													<tbody>
														<tr>
															<td>{t('SizeGuide_Label_ITA_EU')}</td>
															<td>46</td>
															<td>48</td>
															<td>50</td>
															<td>52</td>
															<td>54</td>
															<td>56</td>
															<td>58</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_UK')}</td>
															<td>30</td>
															<td>32</td>
															<td>34</td>
															<td>36</td>
															<td>38</td>
															<td>40</td>
															<td>42</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_InternationalSize')}</td>
															<td>S</td>
															<td>M</td>
															<td>L</td>
															<td>XL</td>
															<td>XXL</td>
															<td>XXXL</td>
															<td>4XL</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
										<div className="table">
											<div className="titleTable">{t('SizeGuide_Label_Shoes')}</div>
											<div>
												<table>
													<tbody>
														<tr>
															<td>{t('SizeGuide_Label_ITA')}</td>
															<td>40</td>
															<td>40.5</td>
															<td>41</td>
															<td>41.5</td>
															<td>42</td>
															<td>42.5</td>
															<td>43</td>
															<td>43.5</td>
															<td>44</td>
															<td>44.5</td>
															<td>45</td>
															<td>45.5</td>
															<td>46</td>
															<td>46.5</td>
															<td>47</td>
															<td>47.5</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_UK')}</td>
															<td>6</td>
															<td>6.5</td>
															<td>7</td>
															<td>7.5</td>
															<td>8</td>
															<td>8.5</td>
															<td>9</td>
															<td>9.5</td>
															<td>10</td>
															<td>10.5</td>
															<td>11</td>
															<td>11.5</td>
															<td>12</td>
															<td>12.5</td>
															<td>13</td>
															<td>13.5</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</TabContent>
								<TabContent
									key="sizeguidetabkidscontent"
									className="tab"
									visibleClassName="contentVisible"
									for={c.SIZEGUIDE_TAB_KIDS}
								>
									<div className="wrapperTables">
										<div className="table">
											<div className="titleTable">{t('SizeGuide_Label_Clothes')}</div>
											<div>
												<table>
													<tbody>
														<tr>
															<td>{t('SizeGuide_Label_ITA_EU')}</td>
															<td>98-104</td>
															<td>104-110</td>
															<td>110-116</td>
															<td>116-122</td>
															<td>122-128</td>
															<td>128-134</td>
															<td>134-140</td>
															<td>140-146</td>
															<td>146-152</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_ApproxAge')}</td>
															<td>3-4 yr</td>
															<td>4-5 yr</td>
															<td>5-6 yr</td>
															<td>6-7 yr</td>
															<td>7-8 yr</td>
															<td>8-9 yr</td>
															<td>9-10 yr</td>
															<td>10-11 yr</td>
															<td>11-12 yr</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
										<div className="table">
											<div className="titleTable">{t('SizeGuide_Label_Shoes')}</div>
											<div>
												<table>
													<tbody>
														<tr>
															<td>{t('SizeGuide_Label_UK')}</td>
															<td>2</td>
															<td>3</td>
															<td>4</td>
															<td>5</td>
															<td>6</td>
															<td>7</td>
															<td>8</td>
															<td>9</td>
															<td>10</td>
															<td>11</td>
															<td>12</td>
															<td>13</td>
															<td>1</td>
															<td>2</td>
															<td>2.5</td>
															<td>3</td>
															<td>4</td>
															<td>5</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_ITA_EU')}</td>
															<td>17.5</td>
															<td>18.5</td>
															<td>20</td>
															<td>21</td>
															<td>22.5</td>
															<td>24</td>
															<td>26.5</td>
															<td>27</td>
															<td>28</td>
															<td>29</td>
															<td>30</td>
															<td>32</td>
															<td>33</td>
															<td>34</td>
															<td>35</td>
															<td>36</td>
															<td>37</td>
															<td>38</td>
														</tr>
														<tr>
															<td>{t('SizeGuide_Label_ApproxAge')}</td>
															<td>3-6 m</td>
															<td>6-9 m</td>
															<td>9-12 m</td>
															<td>12-18 m</td>
															<td>18-24 m</td>
															<td>2 yr</td>
															<td>3 yr</td>
															<td>4 yr</td>
															<td>5 yr</td>
															<td>6 yr</td>
															<td>7 yr</td>
															<td>8 yr</td>
															<td>9 yr</td>
															<td>10 yr</td>
															<td>11 yr</td>
															<td>12 yr</td>
															<td>13 yr</td>
															<td>14 yr</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</TabContent>
							</Tabs>
						</div>
					</div>
				</div>
			</PortalOneColumnLayout>
		);
	}
}
export { SizeGuide };
